import { CtrlCollection } from '@yuigoto/ctrl';
import { GlamboxSessionStore } from 'core/glambox/GlamboxSessionStore';

/**
 * Fornece métodos estáticos genéricos para coisas diversas.
 *
 * @type {Object}
 * @since 0.0.1
 */
export class Utils {
  /**
   * Dicionário de acentuação, para substituição.
   *
   * @type {Object}
   * @private
   */
  static _accents = {
    source: 'ÁÀÄÂÃÅÉÈÊËÍÌÎÏÓÒÔÕØÚÙÛÜÝÇÑáàäâãåéèêëíìîïóòôõøúùûüýÿçñ$&@°ºª¥£¢μ§',
    clean: 'AAAAAAEEEEIIIIOOOOOUUUUYCNaaaaaaeeeeiiiiooooouuuuyycnseaooaylcus',
  };

  /**
   * Retorna o editionId para feedback atual.
   *
   * @param {Boolean} isSuperbox
   */
  static getFeedbackEditionId(isSuperbox = false) {
    let date = new Date(),
      month,
      year,
      subscriptionType;

    year = date.getMonth() === 0 ? date.getFullYear() - 1 : date.getFullYear();
    month = date.getMonth() === 0 ? 12 : date.getMonth();
    month = month.toString();
    if (month.length < 2) month = '0' + month;
    subscriptionType = isSuperbox === true ? 2 : 1;

    return `${subscriptionType}${year}${month}`;
  }

  /**
   *
   * @param {String|Number} editionId
   * @returns {string}
   */
  static editionDateName(editionId) {
    var year = parseInt((editionId / 100) % 10000, 10),
      month = parseInt(editionId % 100, 10),
      date;

    switch (month) {
      case 1:
        date = 'Janeiro, ' + year;
        break;
      case 2:
        date = 'Fevereiro, ' + year;
        break;
      case 3:
        date = 'Março, ' + year;
        break;
      case 4:
        date = 'Abril, ' + year;
        break;
      case 5:
        date = 'Maio, ' + year;
        break;
      case 6:
        date = 'Junho, ' + year;
        break;
      case 7:
        date = 'Julho, ' + year;
        break;
      case 8:
        date = 'Agosto, ' + year;
        break;
      case 9:
        date = 'Setembro, ' + year;
        break;
      case 10:
        date = 'Outubro, ' + year;
        break;
      case 11:
        date = 'Novembro, ' + year;
        break;
      case 12:
        date = 'Dezembro, ' + year;
        break;
    }

    return date;
  }

  /**
   * Retorna status de pagamento
   * @param {String|Number} billingStatusId
   * @returns {string}
   */
  static billingStatus(billingStatusId) {
    var billingStatusName;
    var cssStatus;
    var name;

    switch (billingStatusId) {
      case -1:
        name = 'Teste';
        cssStatus = 'default';
        break;
      case 0:
        name = 'Pendente';
        cssStatus = 'info';
        break;
      case 1:
        name = 'Pago';
        cssStatus = 'success';
        break;
      case 2:
        name = 'Falha';
        cssStatus = 'warning';
        break;
      case 3:
        name = 'Expirado';
        cssStatus = 'important';
        break;
      case 4:
        name = 'Cancelado';
        cssStatus = 'warning';
        break;
      case 5:
        name = 'Estorno';
        cssStatus = 'info';
        break;
      case 6:
        name = 'Parcialmente Estornado';
        cssStatus = 'info';
        break;
    }
    return name;
  }

  /**
   * Retorna status da assinatura
   * @param {String|Number} subscriberStatus
   * @returns {string}
   */
  static subscriberStatusName(subscriberStatus) {
    var name;
    var gbClass;

    switch (subscriberStatus) {
      case 0:
        name = 'Ativo';
        gbClass = 'success';
        break;
      case 1:
        name = 'Dunning';
        gbClass = 'attention';
        break;
      case 2:
        name = 'Cancelado';
        gbClass = 'problem';
        break;
      case 3:
        name = 'Falha no pagamento';
        gbClass = 'attention';
        break;
      case 4:
        name = 'Expirado';
        gbClass = 'problem';
        break;
      case 5:
        name = 'Novo';
        gbClass = 'success';
        break;
      case 6:
        name = 'Confirmado';
        gbClass = 'success';
        break;
      case 7:
        name = 'Cancelado por falha no pagamento nesse mês';
        gbClass = 'problem';
        break;
      case 8:
        name = 'Cancelado por falha no pagamento';
        gbClass = 'problem';
        break;
      case 9:
        name = 'Expirando';
        gbClass = 'attention';
        break;
      case 10:
        name = 'Aguardando confirmação de pagamento';
        gbClass = 'attention';
        break;
    }
    return name;
  }

  /**
   * Converte uma data retornada pela API, para uso temporário.
   *
   * @param {*} date
   * @param {boolean} withTime
   * @returns {String}
   */
  static tempConvertDate(date, withTime = false) {
    let birthday = new Date(date),
      day = Utils.pad(birthday.getDate(), 2),
      month = Utils.pad(birthday.getMonth() + 1, 2),
      year = Utils.pad(birthday.getFullYear(), 4);

    if (withTime) {
      return `${day}/${month}/${year} 00:00:00`;
    }
    return `${day}/${month}/${year}`;
  }

  /**
   * Realiza soft-merge de objetos fornecidos como argumentos, um pouco menos
   * complexo que `Object.assign`.
   *
   * @param {...*} args
   *     Objetos para merge
   * @returns {Object}
   */
  static softMerge() {
    if (arguments.length > 0) {
      let mainArguments = {};

      for (let i = 0; i < arguments.length; i++) {
        let keys = Object.keys(arguments[i]);

        for (let k of keys) {
          mainArguments[k] = arguments[i][k];
        }
      }

      return mainArguments;
    }

    return {};
  }

  /**
   * Realiza merging de dois objetos de forma recursiva.
   *
   * @param {Object} target
   * @param {Object} source
   * @returns {*}
   */
  static mergeObjects(target, source) {
    for (let key of Object.keys(source)) {
      if (source[key] instanceof Object) {
        Object.assign(
          source[key],
          Utils.mergeObjects(target[key], source[key])
        );
      }
    }

    Object.assign(target || {}, source);

    return target;
  }

  /**
   * Retorna uma string URL-encoded do objeto de input.
   *
   * Port de uma reimplementação do jQuery disponível em:
   * https://github.com/knowledgecode/jquery-param/blob/master/jquery-param.js
   *
   * @param {Object|*} toSerialize
   *     Objeto a serializar
   * @returns {String}
   */
  static params(toSerialize) {
    /**
     * Dados serializados.
     *
     * @type {Array}
     */
    let serialized = [];

    /**
     * Adiciona entradas no array de serialização.
     *
     * @param {String} key
     *     Chave associativa
     * @param {*} val
     *     Valor
     */
    let add = (key, val) => {
      val = typeof val === 'function' ? val() : val;
      val = val === null || val === undefined ? '' : val;
      serialized[serialized.length] =
        encodeURIComponent(key) + '=' + encodeURIComponent(val);
    };

    /**
     * Serializa itens dentro do objeto em uma string codificada para URL.
     *
     * @param {String} prefix
     *     Prefixo a ser adicionado à entrada
     * @param {*} obj
     *     Objeto a serializar
     * @returns {Array}
     */
    let buildParam = (prefix, obj) => {
      let i, len, key;

      if (prefix) {
        if (Array.isArray(obj)) {
          for (i = 0, len = obj.length; i < len; i++) {
            buildParam(
              prefix +
                '[' +
                (typeof obj[i] === 'object' && obj[i] ? i : '') +
                ']',
              obj[i]
            );
          }
        } else if (String(obj) === '[object Object]') {
          for (key in obj) {
            buildParam(prefix + '[' + key + ']', obj[key]);
          }
        } else {
          add(prefix, obj);
        }
      } else if (Array.isArray(obj)) {
        for (i = 0, len = obj.length; i < len; i++) {
          if (obj[i].hasOwnProperty('name') && obj[i].hasOwnProperty('value')) {
            add(obj[i].name, obj[i].value);
          } else {
            buildParam('[' + i + ']', obj[i]);
          }
        }
      } else {
        for (key in obj) {
          buildParam(key, obj[key]);
        }
      }

      return serialized;
    };

    return buildParam('', toSerialize).join('&');
  }

  /**
   * Sanitização simples de acentos.
   *
   * @param {String} value
   *     String a ser limpa
   * @returns {String}
   */
  static sanitize(value) {
    for (let i = 0; i < Utils._accents.source.length; i++) {
      value = value.replace(Utils._accents.source[i], Utils._accents.clean[i]);
    }

    return value.replace('ß', 'ss').replace(/^-+|-+$/g, '');
  }

  /**
   * Adiciona zeros ou outro caractere desejado, à esquerda do número indicado.
   *
   * @param {Number} number
   *     Número a ser modificado
   * @param {Number} width
   *     Comprimento da string a ser retornada
   * @param {String} char
   *     Caractere para inserir à esquerda
   * @returns {String}
   */
  static pad(number, width, char = '0') {
    char = char || '0';
    number = number + '';
    return number.length >= width
      ? number
      : new Array(width - number.length + 1).join(char) + number;
  }

  /**
   * Remove caracteres que não sejam dígitos de uma string.
   *
   * @param {String|Number} value
   *     String para limpexa
   */
  static removeNonDigits(value) {
    if (typeof value === 'number') value = value.toString();
    if (value === null || value === undefined || value === '') return '';
    return value.replace(/[^\d]/g, '');
  }

  /**
   * Formata `value` para o `locale` e `currency` desejados.
   *
   * @param {Number} value
   *     Valor a converter
   * @param {String} locale
   *     Código da localidade, padrão `pt-BR´
   * @param {String} currency
   *     Código de três letras representando a moeda, padrão `BRL`
   * @returns {String|Boolean}
   */
  static toCurrency(value, locale = 'pt-BR', currency = 'BRL') {
    if (typeof value !== 'number') return false;

    locale = locale || 'pt-BR';
    currency = currency || 'BRL';

    let numberFormat = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency,
    });
    return numberFormat.format(value);
  }

  /**
   * Retorna nomes dos meses dos resultados de Glampartners
   *
   */

  static getInfluencerResultsMonthNames() {
    let resultMonths = [];
    let today = new Date();
    let months = this.getMonthNames();
    for (let i = 0; i < 4; i++) {
      let d = new Date();
      d = new Date(today.getFullYear(), today.getMonth() - i, 1);
      let monthResult = months[d.getMonth()];

      resultMonths.push(monthResult);
    }
    return resultMonths;
  }

  /**
   * Retorna os nomes dos meses
   *
   */
  static getMonthNames() {
    let monthNames = [
      'Janeiro',
      'Fevereiro',
      'Março',
      'Abril',
      'Maio',
      'Junho',
      'Julho',
      'Agosto',
      'Setembro',
      'Outubro',
      'Novembro',
      'Dezembro',
    ];

    return monthNames;
  }

  static stateToOptions(statesData) {
    let states = [];

    for (let n = 0; n < statesData.length; n++) {
      states.push({
        name: statesData[n].nome,
        value: statesData[n].codigoIbge || statesData[n].codigoCep,
      });
    }

    states.sort((a, b) => {
      return a.name > b.name;
    });

    return states;
  }

  static citiesToOptions = citiesData => {
    let cities = [];

    if (typeof citiesData !== 'undefined') {
      for (let n = 0; n < citiesData.length; n++) {
        cities.push({
          name: citiesData[n].nome,
          //value: citiesData[n].codigoIbge
          value: citiesData[n].codigoCepCidade,
        });
      }
    }

    cities.sort((a, b) => {
      return a.name > b.name;
    });

    return cities;
  };

  /**
   *
   * @param {CtrlCollection} collection
   * @param {function} callback
   */
  static bootstrapControls(collection, callback) {
    for (let control of collection.collection) {
      callback(control);
    }
  }

  /**
   * Retorna o nome da business unit desejada.
   *
   * @param {number} unitId
   *     ID da business unit
   * @returns {string}
   */
  static businessUnitName = (unitId = 0) => {
    switch (unitId) {
      case 1:
        return 'Assinatura';
      case 2:
        return 'Produtos';
      default:
        return 'Publi';
    }
  };

  /**
   * Cria um novo objeto de período.
   *
   * @param {boolean} isArray
   *     Se retorna um array ou objeto
   * @returns {array|object}
   */
  static getPeriodObject = (isArray = false) => {
    return {
      Assinatura: isArray ? [] : {},
      Produtos: isArray ? [] : {},
      Publi: isArray ? [] : {},
    };
  };

  /**
   * Retorna um vetor com períodos.
   *
   * @param {number} months
   *     Quantidade de meses a contar do atual para trás
   * @returns {string[]}
   */
  static getPeriodRange = (months = 4, reverse = false) => {
    const periods = [];

    let date = new Date();
    let month = date.getMonth() + 1;
    let monthWithZero = `0${month}`;
    let year = date.getFullYear();
    let count = months || 4;

    while (count) {
      periods.push(`${month >= 10 ? month : monthWithZero}/${year}`);

      month -= 1;
      monthWithZero = `0${month}`;
      if (month < 1) {
        month = 12;
        year -= 1;
      }

      count -= 1;
    }

    if (reverse) periods.reverse();

    return periods;
  };

  static totalByMonth = (value, reverse = false) => {
    let _table = {};
    let periods = this.getPeriodRange(4, reverse);

    for (let period of periods) {
      _table[period] = 0;
    }

    for (let item of value) {
      if (item && item.periodo && _table[item.periodo] !== undefined) {
        _table[item.periodo] += item.payment;
      }
    }

    return _table;
  };

  /**
   * Traduz os dados para uma tabela horizontal (desktop).
   *
   * @param {object} value
   * @returns {object}
   */
  static translateToHorizontal = value => {
    // Objeto com business units
    let _table = this.getPeriodObject(false);

    // Navegação para criar chaves de payment type
    for (let sale of value) {
      if (sale) {
        let unitName = this.businessUnitName(sale.businessUnit);
        if (!_table[unitName][sale.paymentType]) {
          _table[unitName][sale.paymentType] = {};
        }
      }
    }

    // Chaves de períodos
    const periods = this.getPeriodRange(4, true);

    Object.keys(_table).map(unitName => {
      Object.keys(_table[unitName]).map(typeName => {
        for (let period of periods) {
          _table[unitName][typeName][period] = null;
        }
      });
    });

    // Preenche dados
    for (let sale of value) {
      if (sale && sale.businessUnit && sale.periodo && sale.paymentType) {
        let unitName = this.businessUnitName(sale.businessUnit);
        if (_table[unitName][sale.paymentType][sale.periodo] === null) {
          _table[unitName][sale.paymentType][sale.periodo] = sale;
        }
      }
    }

    return {
      table: _table,
      totals: this.totalByMonth(value, true),
    };
  };

  /**
   * Traduz os dados para uma tabela vertical (mobile).
   *
   * @param {object} value
   * @returns {object}
   */
  static translateToVertical(value) {
    let _table = {};

    // Define períodos
    let periods = this.getPeriodRange(4);
    for (let period of periods) {
      _table[period] = this.getPeriodObject(true);
    }

    // Preenche com dados
    value.forEach(item => {
      if (item && item.periodo && _table[item.periodo]) {
        const periodo = _table[item.periodo];
        let unitName = this.businessUnitName(item.businessUnit);

        if (periodo[unitName] === null) periodo[unitName] = [];
        periodo[unitName].push(item);

        _table[item.periodo] = periodo;
      }
    });

    return {
      table: _table,
      totals: this.totalByMonth(value),
    };
  }
  /**
   * Verifica se está no Portal Glampartners
   */
  static isGp = () => {
    let session = new GlamboxSessionStore();
    let isGp = session.get('isGlampartner');
    return isGp;
  };

  static toDataURL = async url => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);
      return objectUrl;
    } catch (error) {
      throw error;
    }
  };

  static downloadImage = async (url, filename) => {
    const link = document.createElement('a');
    try {
      const href = await Utils.toDataURL(url);
      link.setAttribute('href', href);
    } catch (err) {
      link.setAttribute('href', url);
      console.error(err);
      throw err;
    } finally {
      link.setAttribute('download', filename ?? url);
      link.dispatchEvent(
        new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window,
        })
      );
    }
  };
}
